import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 2650. 以前のプロジェクト（売上）削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/prev_sales_orders/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
};
const destroyPrevSalesOrder = (props: Props): Promise<any> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/prev_sales_orders/${props.id}`
  );
};

export const useDestroyPrevSalesOrder = () => {
  return useMutation({
    mutationFn: destroyPrevSalesOrder,
  });
};
